import axios from 'axios';
import { pathOr } from 'ramda';
import qs from 'qs';

const endPoint = 'https://api.kollecta.io';
const baseURL = `${endPoint}/api`;
const timeout = 2147483647;
const axiosInstance = axios.create({ baseURL, timeout })

axiosInstance.interceptors.request.use((config) => ({
  ...config,
  headers: {
    ...config.headers,
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
  paramsSerializer: qs.stringify,
}))

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
  const statusCode = pathOr(null, ['response', 'status'], error)

  if (statusCode === 401 || statusCode === 403) {
    window.onerror(`authorization: ${statusCode}`, window.location.href)
    window.location.href = '/#/login'
  }
  return Promise.reject(error.response);
})



export default axiosInstance
